var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "schjMap", attrs: { id: "schjMap" } }, [
    _c("img", {
      staticClass: "location",
      attrs: { src: require("images/schj/location.png") },
      on: { click: _vm.location },
    }),
    _c("img", {
      staticClass: "btm-zb",
      attrs: { src: require("@/assets/images/schj/tozb.png"), alt: "" },
      on: { click: _vm.toZb },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }